(function(w,d){
  'use strict';
  if (w.__ES_PDP_PRIORITY_BOOT__) return;
  w.__ES_PDP_PRIORITY_BOOT__ = true;

  var assets = w.__ES_PDP_LAZY_ASSETS || {};
  var loaded = Object.create(null);
  var promises = Object.create(null);

  function once(key, factory){
    if (loaded[key]) return Promise.resolve();
    if (promises[key]) return promises[key];
    promises[key] = factory().then(function(){ loaded[key] = true; });
    return promises[key];
  }

  function loadScript(url){
    if (!url) return Promise.resolve();
    return new Promise(function(resolve, reject){
      var found = d.querySelector('script[src="' + url.replace(/"/g, '\\"') + '"]');
      if (found) {
        if (found.dataset.esLoaded === '1' || found.readyState === 'complete') return resolve();
        found.addEventListener('load', function(){ found.dataset.esLoaded = '1'; resolve(); }, { once:true });
        found.addEventListener('error', reject, { once:true });
        return;
      }
      var s = d.createElement('script');
      s.src = url;
      s.defer = true;
      s.dataset.esDynamic = '1';
      s.onload = function(){ s.dataset.esLoaded = '1'; resolve(); };
      s.onerror = reject;
      d.body.appendChild(s);
    });
  }

  function ensureStyle(url){
    if (!url) return;
    if (d.querySelector('link[rel="stylesheet"][href="' + url.replace(/"/g, '\"') + '"]')) return;
    var l = d.createElement('link');
    l.rel = 'stylesheet';
    l.href = url;
    l.dataset.esDynamic = '1';
    d.head.appendChild(l);
  }

  function whenReady(fn){
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  function ensureRelatedModule(){
    return once('relatedModule', function(){
      ensureStyle(assets.relatedCss);
      return loadScript(assets.relatedJs).then(function(){
        try {
          if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
            w.ES_jqReady(function($){
              try { $(d).trigger('shopify:section:load'); } catch(e) {}
            });
          }
        } catch(e) {}
      });
    });
  }

  function ensureQuickviewBundle(){
    return once('quickviewBundle', function(){
      return ensureRelatedModule()
        .then(function(){ return ensureLensbuilder(); })
        .then(function(){ return loadScript(assets.quickviewJs); })
        .then(function(){ return loadScript(assets.quickviewLensJs); })
        .then(function(){
          try {
            if (w.jQuery && typeof w.quickView === 'function') w.quickView();
            if (w.ES_jqReady && typeof w.ES_jqReady === 'function') {
              w.ES_jqReady(function($){
                try { if (w.quickView) w.quickView(); } catch(e) {}
                try { $(d).trigger('shopify:section:load'); } catch(e2) {}
              });
            }
          } catch(e) {}
        });
    });
  }

  function ensureLensbuilder(){
    if (!assets.hasLensbuilder || !assets.lensbuilderJs) return Promise.resolve();
    return once('lensbuilder', function(){
      ensureStyle(assets.lensbuilderCss);
      return loadScript(assets.lensbuilderJs);
    });
  }


  function ensureFancybox(){
    return once('fancybox', function(){
      return loadScript(assets.fancyboxUmd)
        .then(function(){ return loadScript(assets.fancyboxBinder); });
    });
  }

  function observeRelated(){
    // ES 919: keep PDP lighter by loading related-products runtime only when the section is near view
    // or when the customer shows intent; avoid idle-loading it for every PDP visitor.
    var root = d.querySelector('[data-es-related-root]');
    if (!root) return;
    var kicked = false;
    var kick = function(){
      if (kicked) return;
      kicked = true;
      ensureRelatedModule();
    };

    if ('IntersectionObserver' in w) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            try { io.disconnect(); } catch(e) {}
            kick();
          }
        });
      }, { rootMargin: '2800px 0px' });
      io.observe(root);
    } else if ('requestIdleCallback' in w) {
      w.requestIdleCallback(kick, { timeout: 1400 });
    } else {
      w.setTimeout(kick, 700);
    }

    d.addEventListener('pointerenter', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    }, true);

    d.addEventListener('focusin', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    });

    // Mobile: start warming Quickview as soon as the finger touches the button,
    // so the actual click opens with less delay while keeping initial PDP light.
    d.addEventListener('touchstart', function(ev){
      if (ev.target && ev.target.closest && ev.target.closest('[data-es-related-root] .engoj_btn_quickview')) kick();
    }, { passive:true, capture:true });

    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-related-root] .engoj_btn_quickview') : null;
      if (!btn || loaded.quickviewBundle) return;
      ev.preventDefault();
      ev.stopPropagation();
      ensureQuickviewBundle().then(function(){
        w.setTimeout(function(){ try { btn.click(); } catch(e) {} }, 30);
      });
    }, true);
  }

  function prepareLensbuilderLaunch(){
    if (!assets.hasLensbuilder) return;
    function warm(){ ensureLensbuilder(); }

    d.addEventListener('pointerenter', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    });

    d.addEventListener('touchstart', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (btn) warm();
    }, { passive:true, capture:true });

    d.addEventListener('click', function(ev){
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-es-lensbuilder-launch]') : null;
      if (!btn || loaded.lensbuilder) return;
      ev.preventDefault();
      ev.stopPropagation();
      btn.setAttribute('aria-busy', 'true');
      ensureLensbuilder().then(function(){
        btn.removeAttribute('aria-busy');
        w.setTimeout(function(){ try { btn.click(); } catch(e) {} }, 30);
      }).catch(function(){
        btn.removeAttribute('aria-busy');
      });
    }, true);

    if ('requestIdleCallback' in w) {
      w.requestIdleCallback(warm, { timeout: 3200 });
    } else {
      w.setTimeout(warm, 2400);
    }
  }


  function prepareFancybox(){
    function warm(){ ensureFancybox(); }

    d.addEventListener('pointerenter', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, true);

    d.addEventListener('focusin', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    });

    // Mobile: preload the Fancybox runtime on touchstart, before the click event.
    // This keeps the PDP first paint light but makes image zoom feel more immediate.
    d.addEventListener('touchstart', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (trigger) warm();
    }, { passive:true, capture:true });

    d.addEventListener('click', function(ev){
      var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-fancybox]') : null;
      if (!trigger || loaded.fancybox) return;
      ev.preventDefault();
      ev.stopPropagation();
      ensureFancybox().then(function(){
        w.setTimeout(function(){ try { trigger.click(); } catch(e) {} }, 30);
      });
    }, true);

    if ('requestIdleCallback' in w) {
      w.requestIdleCallback(warm, { timeout: 2600 });
    } else {
      w.setTimeout(warm, 1800);
    }
  }

  whenReady(function(){
    observeRelated();
    prepareLensbuilderLaunch();
    prepareFancybox();
  });
})(window, document);
